import useModalLogic from 'hooks/useModalLogic';
import UploadResource from 'models/upload/resource';
import React, { useContext } from 'react';
import * as Modals from 'components/Modals';
import * as Contexts from './Context';
import * as Forms from './Forms';

type ModalProps = {
  value: UploadResource | undefined,
  onClose: () => void
};

const DeleteModal = ({ value, onClose }: ModalProps) => {
  const { deleteUpload } = useContext(Contexts.default);
  const submit = async () => value && deleteUpload(value);

  const [handleSubmit, handleClose, error] = useModalLogic<UploadResource>(submit, onClose);

  return (
    <Modals.Delete title="Slet upload" onClose={handleClose} open={value !== undefined} onSubmit={handleSubmit}>
      {value && (
        <Forms.Delete value={value} error={error} disabled />
      )}
    </Modals.Delete>
  );
};

export const Delete = () => {
  const { selection, setSelection } = useContext(Contexts.SelectionContext);

  return (
    // eslint-disable-next-line max-len
    <DeleteModal value={selection.deleting} onClose={() => setSelection({ ...selection, deleting: undefined })} />
  );
};

export default Delete;
